import React, { FC } from 'react';
import { WORD_LIST_LENGTH } from '../game/Constants';

interface WordListProps {
    words: string[];
    fadeout: boolean;
}

const WordList: FC<WordListProps> = ({ words, fadeout, children }) => {
    let words1: any = [];
    let words2: any = [];
    let sortedWords = words.sort()
    for (var i = 0; i <= sortedWords.length - 1; i++) {
        if (i < WORD_LIST_LENGTH/2) {
            words1.push(<div key={'word' + i}>{sortedWords[i]}</div>);
        }
        else {
            words2.push(<div key={'word' + i}>{sortedWords[i]}</div>);
        }
    }

    return (
        <div className="word_list_row">
            <div className={'word_list_column' + (fadeout ? ' fadeout' : '')}>
                {words1}
            </div>
            <div className={'word_list_column' + (fadeout ? ' fadeout' : '')}>
                {words2}
            </div>
        </div>
    );
};

export default WordList;
